import { render } from "./kycDocuments.vue?vue&type=template&id=46992023&scoped=true&lang=true"
import script from "./kycDocuments.vue?vue&type=script&lang=js"
export * from "./kycDocuments.vue?vue&type=script&lang=js"

import "./kycDocuments.vue?vue&type=style&index=0&id=46992023&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46992023"]])

export default __exports__